<!--<search class="no-print"></search>-->
<div class="row" style="margin:10px 0px;">
  <div class="col-md-12">
    <div class="panel panel-default" style="border: none;">
      <div class="panel panel-default printing" style="margin-top:10px;">
        <div class="panel-heading">
          <div class="panel-title">
            Beach Status
          </div>
        </div>
        <div class="panel-body" *ngIf="loading">
          <div><i class="fa fa-pulse fa-spinner"></i></div>
        </div>
        <div class="panel-body">
          <div *ngIf="(items | async) as statuses" class="row table-responsive">
            <table class="table table-striped">
              <thead>
              <tr>
                <th>Beach</th>

                <th class="no-print">Previous Sample Date</th>
                <th class="no-print">Previous Result</th>
                <th class="no-print">Previous % above STV</th>
                <th class="no-print">Previous Geomean</th>
                <th class="no-print" style="text-align: center">Previous Status</th>
                <th>Current Sample Date</th>
                <th>Current Result (MPN/100mL)</th>
                <th>Current % above STV</th>
                <th>Current Geomean (MPN/100mL)</th>
                <th style="text-align: center">Current Status</th>
                <th class="no-print" style="text-align: center">Change Sign</th>
              </tr>
              </thead>
              <!-- Moved ng-repeat from tbody to tr -->
              <tbody>
              <tr *ngFor="let item of statuses" style="border: none;"
                  [ngStyle]="item.current.exceeds_criteria && item.current.advisory_reported === false ? {'background-color': '#bf0000', 'color': 'white'} : {}"
                  ngbTooltip="Current sampling results and advisory do not match"
                  [disableTooltip]="!(item.current.exceeds_criteria && item.current.advisory_reported === false)">
                <td style="vertical-align: middle;">
                  {{ item.name }} ({{item.id}})
                </td>
                <td class="no-print" style="vertical-align: middle">
                  {{ item.previous.sample_collection_datetime | date: 'MM/dd/yyyy' }}
                </td>
                <td class="no-print" style="vertical-align: middle">
                  {{ item.previous.entero }}
                </td>
                <td class="no-print" style="vertical-align: middle">
                  {{ item.current.stv }}
                </td>
                <td class="no-print" style="vertical-align: middle">
                  {{ item.previous.geomean }}
                </td>
                <td class="no-print" style="vertical-align: middle; text-align: center">
                  <img *ngIf="item.previous.exceeds_criteria && item.previous.advisory_reported !== undefined"
                       src="assets/BadBeachSign.png"
                       width="33px"/>
                  <img *ngIf="!item.previous.exceeds_criteria&& item.previous.advisory_reported !== undefined"
                       src="assets/GoodBeachSign.png"
                       width="45px"/>
                  <span *ngIf="item.previous.advisory_reported === undefined">
                                            <i class="fa fa-spinner fa-pulse"></i>
                                        </span>
                </td>
                <td style="vertical-align: middle">
                  {{ item.current.sample_collection_datetime | date: 'MM/dd/yyyy' }}
                </td>
                <td style="vertical-align: middle">
                  {{ item.current.entero }}
                </td>
                <td style="vertical-align: middle">
                  {{ item.current.stv }}
                </td>
                <td style="vertical-align: middle">
                  {{ item.current.geomean }}
                </td>
                <td style="vertical-align: middle; text-align: center;">
                  <img *ngIf="item.current.exceeds_criteria && item.current.advisory_reported !== undefined"
                       src="assets/BadBeachSign.png"
                       width="33px"/>
                  <img *ngIf="!item.current.exceeds_criteria && item.current.advisory_reported !== undefined"
                       src="assets/GoodBeachSign.png"
                       width="45px"/>
                <span *ngIf="item.current.advisory_reported === undefined">
                                            <i class="fa fa-spinner fa-pulse"></i>
                                        </span>
<!--                 todo: fix potential advisory error notification -->
<!--                </td>-->
<!--                   <td style="vertical-align: middle; text-align: center;">-->
<!--                       <img *ngIf="item.current.advisory_reported &&item.current.advisory &&item.current.advisory_reported !== undefined"-->
<!--                            class="fa fa-check-square-o fa-lg" style="color: darkgreen;" uib-tooltip="Advisory reported"/>-->
<!--                       <img *ngIf="item.current.advisory_reported && !item.current.advisory && item.current.advisory_reported !== undefined"-->
<!--                            class="fa fa-check-square-o fa-lg" style="color: yellow;" uib-tooltip="Advisory report but may be in error"/>-->
<!--                       <img *ngIf="!item.current.advisory_reported && item.current.advisory && item.current.advisory_reported !== undefined"-->
<!--                            class="fa fa-times fa-lg" style="color: #bf0000;" uib-tooltip="Advisory report may be missing"/>-->
<!--                   </td>-->

                <td style="vertical-align: middle; text-align: center" class="no-print"
                    ngbTooltip="Sign needs to be changed"
                    [disableTooltip]="!(item.current.advisory_reported !== item.previous.advisory_reported && item.previous.advisory_reported !== undefined)">
                <div
                      *ngIf="item.current.advisory_reported && item.previous.advisory_reported &&
                      item.current.advisory_reported.length !== item.previous.advisory_reported.length">
                    <i class="fa fa-refresh fa-lg"></i>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="print-only">
    <div class="pull-left">
      <b>NUMBER OF SITES ON THE ADVISORY: {{totalCurrentAdvisories}}</b>
      <br/>
      MPN - Most Probable Number<br/>
      STV Criteria: 10% of samples collected within 30 days cannot exceed 130 MPN/100mL<br/>
      Geomean Criteria: Geomean of samples collected within 30 days cannot exceed 35 MPN/100mL<br/>
      For Result Readings of "9": Actual reading is <10 (min. MPN of the method)<br/>
      For Result Readings of "24197": Actual reading is >24196 (max. MPN of the method)<br/>
      Use of Method #: ASTMD6503-99<br/>
    </div>
    <div class="pull-right">
      <div style="border-top: solid black 1px; width:200px;">
        Reported by:<br/>
        Monitoring Program
      </div>
      <br/><br/>
      <div style="border-top: solid black 1px; width:200px;">
        Reviewed by:<br/>
        EMAS Division Administrator
      </div>
    </div>
  </div>
</div>
